"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.questions.empty': 'Brak skonfigurowanych pytań dla tego kroku.',
    'onboarding.questions.placeholder.text': 'Wprowadź swoją odpowiedź',
    'onboarding.questions.placeholder.textarea': 'Wprowadź swoją odpowiedź',
    'onboarding.questions.placeholder.number': 'Wprowadź liczbę',
    'onboarding.questions.placeholder.select': '-- Wybierz Opcję --',
    'onboarding.questions.required': '*',
};
